import { render, staticRenderFns } from "./TaxConfig.vue?vue&type=template&id=43c4703e&scoped=true"
import script from "./TaxConfig.vue?vue&type=script&lang=js"
export * from "./TaxConfig.vue?vue&type=script&lang=js"
import style0 from "./TaxConfig.vue?vue&type=style&index=0&id=43c4703e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c4703e",
  null
  
)

export default component.exports